// Enhanced excelUtils.js
import * as XLSX from 'xlsx';

export const exportTableToExcel = (tableRef, options = {}) => {
  const {
    fileName = 'table_export',
    sheetName = 'Sheet1',
    columnWidths = [10, 20, 15],
    addTimestamp = true
  } = options;

  if (!tableRef || !tableRef.current) {
    console.error('Invalid or missing table reference');
    return false;
  }

  try {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(tableRef.current);

    // Apply column widths
    ws['!cols'] = columnWidths.map(width => ({ wch: width }));

    // Optional: Add more formatting
    ws['!autofilter'] = { ref: 'A1:C1' }; // Add filters to headers

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const finalFileName = addTimestamp 
      ? `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`
      : `${fileName}.xlsx`;

    XLSX.writeFile(wb, finalFileName);
    return true;
  } catch (error) {
    console.error('Error exporting table to Excel:', error);
    return false;
  }
};